module.exports = __webpack_public_path__ + "static/media/Arusher-Script.b5f80b24.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Arusher-Script.woff
// module id = 2955
// module chunks = 71